var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('div',{staticClass:"info-container"},[_c('span',{staticClass:"display_name"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }